export const srdConverterUrl = "https://websrd.phactmi.org/";